import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.5988 15.2023H13.5988L17.5988 7.20227V5.20227H11.5988V7.20227H15.5988L11.5988 15.2023ZM8.59875 18.2023C8.04875 18.2023 7.57792 18.0064 7.18625 17.6148C6.79459 17.2231 6.59875 16.7523 6.59875 16.2023V4.20227C6.59875 3.65227 6.79459 3.18144 7.18625 2.78977C7.57792 2.3981 8.04875 2.20227 8.59875 2.20227H20.5988C21.1488 2.20227 21.6196 2.3981 22.0113 2.78977C22.4029 3.18144 22.5988 3.65227 22.5988 4.20227V16.2023C22.5988 16.7523 22.4029 17.2231 22.0113 17.6148C21.6196 18.0064 21.1488 18.2023 20.5988 18.2023H8.59875ZM8.59875 16.2023H20.5988V4.20227H8.59875V16.2023ZM4.59875 22.2023C4.04875 22.2023 3.57792 22.0064 3.18625 21.6148C2.79459 21.2231 2.59875 20.7523 2.59875 20.2023V6.20227H4.59875V20.2023H18.5988V22.2023H4.59875Z" }, null, -1)
  ]))]))
}
export default { render: render }